var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ui-sidepage',{attrs:{"extra-large":"","close":_vm.refreshAndClose,"title":_vm.title,"subtitle":_vm.subtitle}},[_c('estimates-old-page-material-list',{staticClass:"mt-8",attrs:{"context":_vm.context,"context-type":_vm.contextType}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }